import React, { useEffect, useState } from "react";
import { Button, Modal, Spin, Tabs } from "antd";
import style from "./index.module.scss";
import ReadList from "../ReadList";
import { getReadAndUnread, ReadAndUnread } from "../../../../../service/notice";
import Config from "../../../../../config";
import Storage from "../../../../../utils/Storage";

interface ReadModalProps {
    id: number;
    onClose: () => void;
}

export default function ReadModal({ id, onClose }: ReadModalProps) {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<ReadAndUnread>();

    useEffect(() => {
        if (!id) return;
        setLoading(true);

        getReadAndUnread(id)
            .then(setData)
            .finally(() => setLoading(false));
    }, [id]);

    function handleClose() {
        setData(undefined);
        onClose();
    }

    function handleDownload() {
        const token = encodeURIComponent(Storage.get("token") as string);
        window.open(
            `${Config.ApiHost}teacher/message/exportReadAndUnread?messageId=${id}&token=${token}`
        );
    }

    const footer = (
        <div className={style.footer}>
            <Button
                type="primary"
                size="large"
                className={style.button}
                onClick={handleDownload}>
                <img
                    src={require("./img/icon.svg")}
                    width={16}
                    style={{ verticalAlign: "0", marginRight: 10 }}
                />{" "}
                导出名单
            </Button>
        </div>
    );

    return (
        <Modal
            visible={id !== 0}
            footer={footer}
            title="已读人员名单"
            className={style.root}
            width={560}
            onCancel={handleClose}
            destroyOnClose>
            <Spin spinning={loading}>
                <Tabs className={style.tab} defaultActiveKey="1">
                    <Tabs.TabPane
                        tab={`已读(${data?.readList?.length || 0})`}
                        key="1">
                        <ReadList
                            data={data?.readList || []}
                            emptyTip="暂无已读人员"
                        />
                    </Tabs.TabPane>

                    <Tabs.TabPane
                        tab={`未读(${data?.unReadList?.length || 0})`}
                        key="2">
                        <ReadList
                            data={data?.unReadList || []}
                            emptyTip="暂无未读人员"
                        />
                    </Tabs.TabPane>
                </Tabs>
            </Spin>
        </Modal>
    );
}
